<template>
  <div class="columns is-multiline">
    <template v-for="(document, subType) in subTypeLatestDocument" :key="subType">
      <TooltipView :label="subTypeTooltip(document.subType)" type="is-dark">
        <div class="is-flex m-1">
          <i :class="document.fileTypeIcon" class="is-size-3 mx-2 has-text-grey-light" />
          <div class="is-size-5 is-clickable is-link" @click="viewDocument(document)">
            {{ document.name }}
          </div>
        </div>
      </TooltipView>
    </template>
  </div>
</template>

<script>
import { groupBy, orderBy } from 'lodash';
import { CellMixin } from '/@/modules/core/table/mixins/CellMixin';
import { DocumentSubType } from '/@/modules/document/enums/DocumentSubType';
import { SortOrder } from '/@/modules/core/app/constants/SortOrder';
import Lang from '/@/modules/core/app/services/Lang';
import DocumentUIService from '/@/modules/core/app/services/DocumentUIService';
import TooltipView from '@/modules/core/ui/components/wrappers/TooltipView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DocumentListCell',
  mixins: [CellMixin],
  components: { TooltipView },
  computed: {
    subTypeLatestDocument() {
      const groupedDocuments = groupBy(this.cellData.get(), 'subType');
      Object.keys(groupedDocuments).forEach((key) => {
        const documents = groupedDocuments[key];
        [groupedDocuments[key]] = orderBy(
          documents,
          [(document) => new Date(document.updatedAt)],
          [SortOrder.DESC]
        );
      });
      return groupedDocuments;
    }
  },
  methods: {
    viewDocument(document) {
      DocumentUIService.openUrl(document.url);
    },
    subTypeTooltip(subType) {
      return `${Lang.t('core.latest')} ${DocumentSubType.getByKey(subType)?.value || ''}`;
    }
  }
};
</script>
